var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatDeletedMessage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId,
    stroke: "#8a8a8a",
    strokeWidth: 1,
    strokeLinecap: "square",
    strokeLinejoin: "miter",
    fill: "none",
    color: "#8a8a8a",
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "notAllowedIconTitle"
  }, "Not Allowed") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "notAllowedIconTitle"
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "square",
    d: "M5,5 L19,19"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatDeletedMessage);
export default __webpack_public_path__ + "static/media/ChatDeletedMessage.d3be9c1d599f144f4307b8b9ba71f7e0.svg";
export { ForwardRef as ReactComponent };